import { gql } from 'graphql-tag'
import { bookNavigationFields } from './old_queries'

export const getReader = gql`
  query GetReader($id: Int!) {
    getReader(id: $id) {
      id
      userId
      name
      email
      accessToken
      permissions
      accessExpireDate
      teacherId
      teacherPermissions
    }
  }
`

export const getIsFavoriteBook = gql`
  query IsFavoriteBook($slug: String) {
    me {
      id
      reader {
        id
        isFavoriteBook(slug: $slug)
      }
    }
  }
`

export const getOnboardingThemes = gql`
  query listOnboardingThemes {
    listOnboardingThemes {
      id
      name
      iconName: icon
    }
  }
`

export const getCollections = gql`
  query Collections($contentFilter: String) {
    me {
      id
      reader {
        id
        collections(contentFilter: $contentFilter) {
          id
          name
          image
        }
      }
    }
  }
`

export const getHighlightsBooks = gql`
  query highlightsBooks($contentFilter: String) {
    me {
      id
      reader {
        id
        highlightsv2(contentFilter: $contentFilter) {
          id
          bookShelfItems {
            book {
              name
              author
              slug
              degree
              imageUrlThumb
              language
              premiumLock
              hasAudioBook
            }
            mascot
          }
          isHighlight
          name
        }
      }
    }
  }
`

export const getFavoritesBooksByRelay = gql`
  query relayPaginatedFavorites(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: String
    $hasStoryTree: Boolean = false
  ) {
    me {
      id
      reader {
        id
        relayPaginatedFavorites(
          after: $after
          before: $before
          first: $first
          last: $last
          order: $order
        ) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              name
              hasEbook
              hasAudioBook
              author
              slug
              degree
              imageUrlThumb
              imageUrlThumbLow
              premiumLock
              lexileLevel @include(if: $hasStoryTree)
              language
              favoritesVisibility @client
              publisher {
                id
              }
              activities {
                moduleId
              }
              qualeActivities {
                moduleId
              }
              sentirActivities {
                moduleId
              }
            }
            cursor
          }
        }
      }
    }
  }
`

export const getViewedBooksByRelay = gql`
  query relayPaginatedViewedBooks(
    $after: String
    $before: String
    $contentFilter: String
    $first: Int
    $isReading: Boolean
    $order: String
    $hasStoryTree: Boolean = false
  ) {
    me {
      id
      reader {
        id
        relayPaginatedViewedBooks(
          after: $after
          before: $before
          contentFilter: $contentFilter
          first: $first
          isReading: $isReading
          order: $order
        ) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              book {
                name
                author
                slug
                degree
                imageUrlThumb
                imageUrlThumbLow
                premiumLock
                hasAudioBook
                hasEbook
                language
                lexileLevel @include(if: $hasStoryTree)
              }
            }
            cursor
          }
        }
      }
    }
  }
`

export const BookLastInteraction = gql`
  query BookLastInteraction($slug: String!) {
    bookDetails(slug: $slug) {
      slug
      lastInteraction
    }
  }
`

export const MainScreenSuggestionsQuery = gql`
  query MainScreenSuggestionsv3(
    $page: Int
    $perPage: Int
    $contentFilter: String!
    $degree: String
    $limit: Int
  ) {
    me {
      id
      reader {
        id
        mainScreenSuggestionsv3(
          page: $page
          perPage: $perPage
          contentFilter: $contentFilter
        ) {
          id
          name
          subtitle
          isHighlight
          bookShelfItems(limit: $limit, degree: $degree) {
            id
            book {
              name
              author
              language
              slug
              degree
              imageUrlThumb
              premiumLock
              hasAudioBook
            }
          }
        }
      }
    }
  }
`

export const getReaderEnglishLevels = gql`
  query getReaderEnglishLevels {
    me {
      id
      reader {
        listEnglishLevels {
          type
          levels
        }
      }
    }
  }
`

export const allDetailsBookQuery = gql`
  ${bookNavigationFields}

  query Book($slug: String!) {
    me {
      id
      reader {
        id
        isFavoriteBook(slug: $slug)
        viewedBookPosition: getViewedBookPosition(slug: $slug)
      }
    }
    bookDetails(slug: $slug) {
      id
      authors
      downloadUrl
      ...bookNavigationFields
      relatedContents {
        source
        url
      }
      bookCharacteristic {
        characteristic {
          name
        }
      }
      bookTheme {
        theme {
          name
        }
      }
      bookThema {
        thema {
          id
          name
          code
          uiName
        }
      }
      bookCategory {
        category {
          name
        }
      }
      customCategories {
        name
      }
      bookDegree {
        degree
      }
      language
      publisher {
        id
        name
      }
      activities {
        id
        title
        bookCount
        isBncc
        estimatedCompletionTimeInSeconds
        authorInfo {
          name
          school
        }
        examQuestions {
          id
          type
          bnccAbilityExamQuestion {
            id
            bnccAbility {
              id
              code
            }
          }
        }
        publicDataActivity {
          id
          objective
          degreeRange
          tags {
            name
          }
          textualGenres {
            name
          }
          generalSkills {
            description
          }
        }
        books {
          author
          name
          imageUrlThumb
        }
      }
      pendingActivities {
        id
        title
        bookCount
        isBncc
        estimatedCompletionTimeInSeconds
        authorInfo {
          name
          school
        }
        examQuestions {
          id
          type
          bnccAbilityExamQuestion {
            id
            bnccAbility {
              id
              code
            }
          }
        }
        publicDataActivity {
          id
          objective
          degreeRange
          tags {
            name
          }
          textualGenres {
            name
          }
          generalSkills {
            description
          }
        }
        books {
          author
          name
          imageUrlThumb
        }
      }
      qualeActivities {
        id
        title
        examQuestions {
          type
        }
      }
      sentirActivities {
        id
        title
        bookCount
        isBncc
        moduleId
        examQuestions {
          type
        }
        authorInfo {
          name
          school
        }
        books {
          author
          name
          imageUrlThumb
        }
      }
      imprint
      readingLevel
      englishLevels {
        type
        levels
      }
      series
      subtitle
      edition
      publicationYear
      note
      hasEbook
      disabled
    }
  }
`

export const bookRecommendedContent = gql`
  query BookRecommendedContent($slug: String!) {
    bookDetails(slug: $slug) {
      slug
      recommendedContentShelves {
        identifier
        title
        contentShelf {
          name
          author
          slug
          imageUrlThumb
          imageUrlThumbLow
          premiumLock
          hasAudioBook
        }
      }
    }
  }
`

export const articleRecommendedContent = gql`
  query ArticleRecommendedContent($id: Int!) {
    articleDetails(id: $id) {
      id
      recommendedContentShelves {
        identifier
        title
        shelfItems {
          ... on Article {
            __typename
            id
            title
            author
            image
            subtitle
            publishDate
            degree
            categories {
              name
              slug
              iconIdentifier
            }
          }
        }
      }
    }
  }
`

export const getActivity = gql`
  query getActivity($activityId: Int!) {
    getActivity(activityId: $activityId) {
      authorInfo {
        facebookPhoto
        name
        school
      }
      moduleId
      books {
        slug
      }
      description
      examQuestions {
        id
      }
      id
      isReady
      publicDataActivity {
        id
      }
      submittedToPublic
      title
    }
  }
`

//Atualidades
export const articleShelves = gql`
  query articleShelves($page: Int!, $perPage: Int!) {
    me {
      id
      reader {
        id
        articleShelves {
          id
          description
          name
          articles(page: $page, perPage: $perPage) {
            id
            author
            degree
            description
            subtitle
            image
            title
            publishDate
            categories {
              name
              slug
              iconIdentifier
            }
          }
        }
      }
    }
  }
`

export const listArticles = gql`
  query listArticles($input: ListArticlesInput!) {
    listArticles(input: $input) {
      articles {
        id
        author
        description
        image
        title
        subtitle
        publishDate
        publisher
        degree
      }
      totalEntries
    }
  }
`

export const getArticleDetails = gql`
  query articleDetails($id: Int!) {
    articleDetails(id: $id) {
      activities {
        id
        title
        isBncc
        moduleId
        examQuestions {
          type
        }
      }
      author
      imageAuthor
      consumptionStatus
      coverSubtitle
      coverTitle
      degree
      description
      htmlContent
      htmlRaw
      id
      image
      title
      subtitle
      publishDate
      publisher
      schoolSegment {
        label
        abbreviation
        value
        recommendedDegrees
      }
    }
  }
`

export const magazinesShelf = gql`
  query magazinesShelf {
    me {
      id
      reader {
        id
        magazinesShelf {
          date
          name
          image
          url
          cid
        }
      }
    }
  }
`

export const newspaperShelf = gql`
  query newspaperShelf {
    me {
      id
      reader {
        id
        newspaperShelf {
          date
          name
          image
          url
          cid
        }
      }
    }
  }
`

export const bookRemovalDates = gql`
  query bookRemovalDates($slugs: [String]!) {
    bookRemovalDates(slugs: $slugs) {
      deactivationDate
      slug
    }
  }
`

export const searchArticles = gql`
  query searchArticles(
    $page: Int!
    $perPage: Int!
    $term: String
    $onlyPublished: Boolean!
  ) {
    searchArticles(
      input: {
        page: $page
        perPage: $perPage
        term: $term
        onlyPublished: $onlyPublished
      }
    ) {
      id
      title
      image
      author
      degree
      subtitle
      publishDate
    }
  }
`

export const searchBook = gql`
  query searchBookV3(
    $searchTerm: String
    $page: Int
    $perPage: Int!
    $opts: String
    $hasStoryTree: Boolean = false
  ) {
    searchBookV3(
      searchTerm: $searchTerm
      page: $page
      perPage: $perPage
      opts: $opts
    ) {
      searchFilters
      books {
        name
        slug
        author
        degree
        hasAudioBook
        hasEbook
        isReadingTrail
        language
        imageUrlThumb
        imageUrlThumbLow
        lexileLevel @include(if: $hasStoryTree)
        publisher {
          id
          name
        }
      }
    }
  }
`

export const showBookShelf = gql`
  query showBookShelf($bookShelfId: Int!, $limit: Int, $page: Int) {
    showBookShelf(bookShelfId: $bookShelfId) {
      name
      subtitle
      degreeRange
      contentFilter
      isHighlight
      acervoType
      id
      type
      description
      image
      bgColor
      bookShelfItems(limit: $limit, page: $page) {
        book {
          slug
          name
          imageUrlThumb
          author
          hasAudioBook
          degree
          premiumLock
        }
        bookShelfId
        id
        mascot
      }
      bookShelfItemsCount
    }
  }
`

export const searchIndependetActivities = gql`
  query searchIndependentActivities(
    $input: SearchIndependentActivitiesInput!
    $searchTerm: String
  ) {
    searchIndependentActivities(input: $input) {
      independentActivities {
        title
        subtitle
        readerId
        entity
        reader
        appliedActivityId
        status
        grade
        moduleId
        articles {
          image
          title
        }
        books {
          imageUrlThumb
          name
        }
      }
      totalEntries(searchTerm: $searchTerm)
    }
  }
`

export const contentIndicationsToMeQuery = gql`
  query contentIndicationsToMe {
    me {
      indicationsToMe {
        id
        dueDate
        indicatedAt
        sourceUser {
          name
          isTeacher
          isFamily
        }
        content {
          identifier
          type
          contentDetails {
            ... on Book {
              name
              author
              slug
              imageUrlThumb
            }
            ... on Article {
              id
              title
              image
              author
            }
          }
        }
      }
    }
  }
`

export const contentIndicationsByMeQuery = gql`
  query contentIndicationsByMe {
    me {
      indicationsMadeByMe {
        id
        dueDate
        indicatedAt
        target {
          targetDetails {
            ... on Reader {
              user {
                name
              }
            }
            ... on Entity {
              name
            }
          }
        }
        content {
          identifier
          type
          contentDetails {
            ... on Book {
              name
              author
              slug
              imageUrlThumb
            }
            ... on Article {
              id
              title
              image
              author
            }
          }
        }
      }
    }
  }
`

export const searchAvailableReadersToIndicate = gql`
  query searchAvailableReadersToIndicate($term: String!) {
    me {
      id
      teacher {
        entitiesSubtreeFlat
        searchAvailableReadersToIndicate(term: $term)
      }
    }
  }
`

export const searchBookForAutoComplete = gql`
  query searchBookForAutoComplete($searchTerm: String!) {
    searchBook(searchTerm: $searchTerm) {
      name
      slug
    }
  }
`

export const listReadersWithSameDegree = gql`
  query listReadersSameDegree($term: String!) {
    me {
      id
      reader {
        id
        listReadersSameDegree(term: $term)
      }
    }
  }
`

export const existsAtLeastOnePlantedTree = gql`
  query existsAtLeastOnePlantedTree {
    me {
      id
      reader {
        id
        existsAtLeastOnePlantedTree
      }
    }
  }
`

export const sentirHomeContents = gql`
  query sentirHomeContents(
    $limit: Int
    $page: Int
    $degree: String
    $pillar: String!
  ) {
    sentirHomeContents(degree: $degree, pillar: $pillar) {
      pillars {
        name
        iconUrl
      }

      courseBooks {
        name
        author
        slug
        degree
        imageUrlThumb
        language
        premiumLock
        hasAudioBook
      }

      bookShelves {
        id
        name
        subtitle
        active
        description
        bookShelfItems(limit: $limit, page: $page) {
          id
          bookShelfId
          book {
            name
            author
            slug
            degree
            imageUrlThumb
            language
            premiumLock
            hasAudioBook
          }
        }
      }

      secondaryEmotions {
        happy {
          name
          slug
        }
        neutral {
          name
          slug
        }
        sad {
          name
          slug
        }
      }
    }
  }
`

export const sentirHomeContentsOnboarding = gql`
  query sentirHomeContentsOnboarding($degree: String, $pillar: String!) {
    sentirHomeContents(degree: $degree, pillar: $pillar) {
      pillars {
        name
        iconUrl
      }
    }
  }
`

export const getRecommendedBooks = gql`
  query recommendedBooks {
    recommendedBooks {
      slug
      imageUrlThumbLow
      imageUrlThumb
    }
  }
`

export const getDataHomeForestPreview = gql`
  query DataHomeForest($count: Int) {
    me {
      id
      reader {
        id
        forest {
          id
          coins
          treeListings(count: $count) {
            id
            image
          }
          waterDropDetails {
            currentDrops
            maxDrops
          }
        }
      }
    }
  }
`

export const getUserCoins = gql`
  query getUserCoins {
    me {
      id
      reader {
        id
        forest {
          id
          coins
        }
      }
    }
  }
`

export const getRecommendedBookShelf = gql`
  query getRecommendedBookShelf {
    me {
      id
      reader {
        id
        bookSuggestions {
          name
          author
          slug
          degree
          imageUrlThumb
          language
          premiumLock
          hasAudioBook
        }
      }
    }
  }
`

export const runningRecordsBookshelvesQuery = gql`
  query runningRecordsBookshelvesQuery($page: Int, $per_page: Int) {
    me {
      id
      reader {
        id
        runningRecordsAssessmentBooksSuggested(
          input: { page: $page, perPage: $per_page }
        ) {
          name
          author
          slug
          degree
          imageUrlThumb
          language
          premiumLock
          hasAudioBook
        }
      }
    }
  }
`

export const EmotionJournalEntriesByMonth = gql`
  query emotionJournalEntriesByMonth(
    $month: Int!
    $year: Int!
    $readerId: Int
  ) {
    emotionJournalEntriesByMonth(
      month: $month
      year: $year
      readerId: $readerId
    ) {
      date
      entries {
        id
        primaryEmotion
        secondaryEmotions {
          slug
        }
        note
        blockNote
        insertedAt
        emotionColor
      }
    }
  }
`

export const SentirSubpagesQuery = gql`
  query SentirSubpagesQuery($pillar: String!) {
    sentirHomeContents(pillar: $pillar) {
      subpages
    }
  }
`

export const teacherClasses = gql`
  query teacherClasses($degree: String!) {
    me {
      id
      teacher {
        id
        teacherClasses(degree: $degree) {
          id
          name
          degree
        }
      }
    }
  }
`

export const classLastJournalEntries = gql`
  query classLastJournalEntries($class_id: Int!) {
    classLastJournalEntries(classId: $class_id) {
      reader {
        id
        name
        lastEntries
        showAlert
      }
    }
  }
`

export const consumedContentContentReportQuery = gql`
  query ConsumedContentContentReport(
    $contentType: ContentType!
    $entityId: Int!
  ) {
    consumedContentsContentReport(
      contentType: $contentType
      entityId: $entityId
    ) {
      content {
        identifier
        type
        contentDetails {
          ... on Book {
            name
            author
            slug
          }
          ... on Article {
            id
            title
            author
          }
        }
      }
      openedCount
      fullyConsumedCount
    }
  }
`

export const mostReadContentByType = gql`
  query mostReadContentByType($contentType: ContentType!) {
    mostReadContentByType(contentType: $contentType) {
      content {
        contentDetails {
          ... on Book {
            name
            author
            slug
          }
          ... on Article {
            id
            author
            degree
            description
            subtitle
            image
            title
            publishDate
            categories {
              name
              slug
              iconIdentifier
            }
          }
        }
      }
      fullyConsumedCount
    }
  }
`

export const contentConsumptionDetailsByEntityAndContentReport = gql`
  query contentConsumptionDetailsByEntityAndContentReport(
    $entityId: Int!
    $contentIdentifier: String!
    $contentType: ContentType!
  ) {
    consumedContentsByEntityAndContentReport(
      input: {
        entityId: $entityId
        contentIdentifier: $contentIdentifier
        contentType: $contentType
      }
    ) {
      id
      user {
        id
        name
      }
      content {
        contentDetails {
          ... on Article {
            id
            title
            author
          }
        }
      }
      status
      firstConsumedAt
    }
  }
`

export const contentConsumptionByUserReport = gql`
  query contentConsumptionByUserReport($readerId: Int!) {
    consumedContentsByUserReport(readerId: $readerId) {
      status
      firstConsumedAt
      content {
        identifier
        type
        contentDetails {
          ... on Article {
            title
            author
          }
          ... on Book {
            name
            author
          }
        }
      }
      user {
        name
      }
    }
  }
`

export const articleSchoolSegments = gql`
  query articleSchoolSegments {
    articleSchoolSegments {
      value
      label
      abbreviation
      recommendedDegrees
    }
  }
`

export const contentCategoryShelves = gql`
  query contentCategoryShelves($type: ContentType!) {
    contentCategoryShelves(type: $type) {
      contents {
        contentDetails {
          ... on Article {
            id
            title
            image
            description
            subtitle
            degree
            publishDate
            categories {
              name
              slug
              iconIdentifier
            }
          }
        }
        identifier
        type
      }
      iconIdentifier
      name
      slug
    }
  }
`

export const shouldShowCsatFormQuery = gql`
  query shouldShowCsatForm {
    me {
      id
      reader {
        id
        showCsatForm(context: GAMING)
      }
    }
  }
`
